// ==============================
// Alert
// ==============================

/* eslint quote-props: ["error", "as-needed"] */

import colors from './colors'
import theme from '../theme'

// Prepare variants
const colorVariants = {}
Object.keys(colors).forEach((color) => {
  colorVariants[color] = {
    backgroundColor: colors[color].background,
    borderColor: colors[color].border,
    color: colors[color].text,
  }
})

// Prepare headings
const headingTagnames = {}
const textTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']

textTags.forEach((tag) => {
  headingTagnames[tag] = { color: 'inherit' }
})

const linkStyles = {
  color: 'inherit',
  textDecoration: 'underline',

  ':hover': { color: 'inherit' },
  ':focus': { color: 'inherit' },
}

export const styles = {
  alert: {
    borderColor: 'transparent',
    borderRadius: theme.alert.borderRadius,
    borderStyle: 'solid',
    borderWidth: theme.alert.borderWidth,
    margin: theme.alert.margin,
    padding: theme.alert.padding,
  },

  // tagnames
  a: linkStyles,
  Link: linkStyles,
  strong: {
    fontWeight: 600,
  },

  // headings
  ...headingTagnames,

  // colors
  ...colorVariants,
}

export default styles
